export const ADD_DAYOFF_LOCAL = 'ADD_DAYOFF_LOCAL';

export function dayOffAddLocalRequest(data) {
    return {
        type:ADD_DAYOFF_LOCAL,
        payload: {data},
    };
}

export const ADD_SURVEY_LOCAL = 'ADD_SURVEY_LOCAL';

export function surveyAddLocalRequest(data) {
    return {
        type:ADD_SURVEY_LOCAL,
        payload: {data},
    };
}

export const DAYOFF_MESSAGE = 'DAYOFF_MESSAGE';

export function dayOffMessageRequest(data) {
    return {
        type:DAYOFF_MESSAGE,
        payload: {data},
    };
}

export const SURVEY_MESSAGE = 'SURVEY_MESSAGE';

export function surveyMessageRequest(data) {
    return {
        type:SURVEY_MESSAGE,
        payload: {data},
    };
}